import { useSelector } from "react-redux";
import { motion } from "framer-motion";

export default function Projects() {
  const { loading, error, data } = useSelector((state) => state.portfolio);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading projects</div>;

  // Animation variants for cards and images
  const cardVariant = {
    hidden: { opacity: 0, y: 40, scale: 0.95 },
    visible: { opacity: 1, y: 0, scale: 1 }
  };

  const imageVariant = {
    initial: { scale: 1 },
    hover: { scale: 1.05 }
  };

  return (
    <section id="projects" className="py-20 bg-gray-100 dark:bg-gray-900">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-heading font-bold mb-10 text-center text-gray-900 dark:text-white">
          {data.projectsTitle || "PROJECTS"}
        </h2>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {data.projects.map((proj, idx) => (
            <motion.div
              key={proj.title || idx}
              variants={cardVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              whileHover={{ scale: 1.03, boxShadow: '0 4px 24px rgba(55,65,81,0.13)' }}
              className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg flex flex-col items-center py-8 px-6 transition-all cursor-pointer"
              style={{ boxShadow: '0 2px 12px rgba(55,65,81,0.08)' }}
            >
              <motion.img
                src={proj.image || '/assets/default_project.png'}
                alt={proj.title}
                className="w-20 h-20 object-contain mx-auto mb-5 transition-transform"
                variants={imageVariant}
                initial="initial"
                whileHover="hover"
                style={{ borderRadius: '16px', background: '#F3F4F6' }}
              />

              <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-white text-center">
                {proj.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-300 text-center mb-3">
                {proj.description}
              </p>
              {/* Tech Stack tags (optional, if included) */}
              {proj.tech && (
                <div className="flex flex-wrap gap-2 justify-center mb-4">
                  {proj.tech.map((tech, i) => (
                    <span key={tech + i} className="text-xs font-medium px-3 py-1 bg-gray-200 dark:bg-gray-700 rounded-full">
                      {tech}
                    </span>
                  ))}
                </div>
              )}

              {proj.project_link && (
                <motion.a
                  href={proj.project_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{
                    scale: 1.08,
                    backgroundColor: "#3730A3",
                    color: "#FFF"
                  }}
                  transition={{ duration: 0.2 }}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg shadow transition-colors focus:outline-none"
                >
                  View Project
                  {/* You can add an external link icon here if you want */}
                </motion.a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
